import LegacyInterceptor from '../LegacyInterceptor'

const api = new LegacyInterceptor()

export default {
  getRecebimentos(dataEpochInicial, dataEpochFinal) {
    return api.get(`medico/producao/aprovada/dashboard/${encodeURI(dataEpochInicial)}/${encodeURI(dataEpochFinal)}`)
  },

  getRecebimentosByMedicoId(medicoId: string) {
    return api.get(`/conciliacao/recebimentos/${medicoId}`)
  },

  getRecebimentosFuturos(dataEpochInicial, dataEpochFinal) {
    return api.get(`medico/producao/aprovada/dashboard/previsto/${encodeURI(dataEpochInicial)}/${encodeURI(dataEpochFinal)}`)
  },

  getRecebimentosV2() {
    return api.get(`users/current/recebimentos`)
  },

  getRecebimentoItemsV2(contratoId: String, data: String) {
    return api.get(`users/current/recebimentos/items?contratoid=${contratoId}&datarecebimento=${data}`)
  },
  getValoresReceber(qnt: number) {
    return api.get(`users/current/relatorios/valores-receber?QuantidadeMesesParaExibir=${qnt}`)
  },

  getValoresPendentes(qnt: number) {
    return api.get(`users/current/relatorios/valores-pendentes?QuantidadeMesesParaExibir=${qnt}`)
  },

  getValoresRecebidos(qnt: number) {
    return api.get(`users/current/relatorios/valores-recebidos?QuantidadeMesesParaExibir=${qnt}`)
  },
}
